/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ApplicationType {
    GODMODE = 'godmode',
    DEALSTACK = 'dealstack',
    INVESTOR = 'investor',
}
